/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    bool, number, object, shape,
} from 'prop-types';

import { useQuery } from '@apollo/react-hooks';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon';

import { GRAPHQL_ENV } from '../../../../../../../gql';
import findContent from '../../../../../../../gql/queries/findContent';
import RegulatoryFeeInformation from './RegulatoryFeeInformation';
import { setLocale } from '../../../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    root: {
        color: theme.palette.common?.black,
    },
    text: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '1em',
        lineHeight: '26px',
        color: theme.palette.common?.black,
        letterSpacing: '-0.5px',
        [theme.breakpoints.down(960)]: {
            fontSize: '1em',
        },
    },
    textConfirmation: {
        fontSize: '16px',
        color: '#2f2f2f',
    },
    infoIconWrapper: {
        display: 'inline',
    },
    infoIcon: {
        zIndex: '1',
        fontSize: '17px',
        borderRadius: '50%',
        position: 'relative',
        margin: ' 0 0 0 2px',
        padding: '1px 0 0 2px',
        verticalAlign: 'middle',
        color: theme.palette.white,
        backgroundColor: theme.palette.colorNeutral70,
    },
    closeIcon: {
        backgroundColor: theme.palette.white,
        color: theme.palette.primary?.main,
        borderRadius: '50%',
        fontSize: '17px',
        padding: '0',
        margin: ' 2px 0 0 2px',
        verticalAlign: 'middle',
    },
    paperExpanded: {
        height: 'auto',
    },
    shippingPaperExpanded: {
        height: 'auto',
    },
    paperCollapsed: {
        height: '0px',
    },
    textFloral: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '15px',
        color: '#757575',
        letterSpacing: '-0.5px',
        [theme.breakpoints.down(960)]: {
            fontSize: '16px',
        },
    },
    textFood: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
        letterSpacing: '-0.5px',
        [theme.breakpoints.down(960)]: {
            fontSize: '14px',
        },
    },
    textFloralConfirmation: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '16px',
        color: '#757575',
        letterSpacing: '-0.5px',
        [theme.breakpoints.down(960)]: {
            fontSize: '15px',
        },
    },
    textFoodConfirmation: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.87)',
        letterSpacing: '-0.5px',
        [theme.breakpoints.down(960)]: {
            fontSize: '15px',
        },
    },
    adujustMarginTop: {
        marginTop: '-5px',
        '&.order-detail': {
            width: '220px',
            maxWidth: '220px',
            marginBottom: '10px',
            display: 'inline-block',
            '& ~ div': {
                display: 'inline-block',
            },
        },
    },
});

const DeliveryExtraFee = ({
    flags,
    classes,
    orderDetail,
    dataDictionary,
    stateDeliveryFee,
    isConfirmationPage = false,
}) => {
    const [openToggled, setOpenToggled] = useState({});
    const stateDeliveryFeeEnabled = flags['is-state-delivery-fee-enabled'];
    const isInternationalization = flags['is-internationalization-enabled'];

    const deliveryFeesList = stateDeliveryFee || [];

    const deliveryFeesKeys = Object.keys(deliveryFeesList) || [];
    const deliveryInfoList = [];

    const contentType = 'regulatory_fees';
    const surchargeIds = Object.keys(deliveryFeesList).map((key) => `\\"${key}\\"`);
    const findContentOptions = {
        brand: 'global',
        contentType,
        query: `\\"surcharge_id\\" : {\\"$in\\": [${surchargeIds}]}`,
        GRAPHQL_ENV,
        locale: setLocale(),
    };

    const WRAP_UP_QUERY = findContent(findContentOptions);
    const { error, data } = useQuery(WRAP_UP_QUERY);

    if (error) {
        return null;
    }

    const classText = classes.textFloralConfirmation;

    const handleOpenToggled = (key) => {
        // open tooltip according of the delivery key
        const listToggled = {
            ...openToggled,
            [key]: !openToggled[key],
        };

        setOpenToggled(listToggled);
    };

    if (!stateDeliveryFeeEnabled) {
        if (openToggled) {
            setOpenToggled(false);
        }
        return null;
    }

    if (data?.findContent?.content?.entries?.length > 0) {
        data?.findContent?.content?.entries.forEach((itemFee) => {
            deliveryInfoList[`${itemFee['surcharge_id']}`] = itemFee;
        });
    }

    if (deliveryFeesKeys.length > 0) {
        const htmlLineFeeCharges = deliveryFeesKeys.map((deliveryFeeKey) => (
            <React.Fragment key={`deliveryFee${deliveryFeeKey}`}>
                <Grid id={`delivery-fee-label-${deliveryFeeKey}`} className={`${classes.adujustMarginTop} ${orderDetail ? 'order-detail' : ''}`} data-testid={`delivery-fee-label-${deliveryFeeKey}`} item xs={8} md={9} lg={8} align="left" key={`delivery-fee-label-${deliveryFeeKey}`}>
                    <Typography component="span" className={`${classText} ${isConfirmationPage ? classes.textConfirmation : ''}`}>
                        {deliveryFeeKey === '2' ? (dataDictionary?.['Fuel Surcharge'] || 'Fuel Surcharge:') : null}
                        {deliveryFeeKey === '4' ? (dataDictionary?.['Regulatory Fees'] || 'Regulatory Fees:') : null}
                        {
                            !isConfirmationPage && deliveryInfoList[deliveryFeeKey]
                            && (
                                <span className={classes.infoIconWrapper}>
                                    <SvgIcon
                                        data-testid="delivery-fee-info-btn"
                                        className={!openToggled[deliveryFeeKey] ? classes.infoIcon : classes.closeIcon}
                                        onClick={() => handleOpenToggled(deliveryFeeKey)}
                                    >
                                        {openToggled[deliveryFeeKey] ? (
                                            <path d="M10.5,0.5c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S16,0.5,10.5,0.5L10.5,0.5zM15.5,14.1l-1.4,1.4l-3.6-3.6l-3.6,3.6l-1.4-1.4l3.6-3.6L5.5,6.9l1.4-1.4l3.6,3.6l3.6-3.6l1.4,1.4l-3.6,3.6L15.5,14.1L15.5,14.1z" />
                                        ) : (
                                            <path d="M12.4,14.9c0-0.2-0.3-0.4-0.5-0.4h-0.4v-6c0-0.2-0.2-0.4-0.4-0.4h-2c-0.2,0-0.4,0.2-0.4,0.4v0.7c0,0.2,0.2,0.4,0.4,0.4h0.4v4.9H9.1c-0.2,0-0.4,0.2-0.4,0.4v0.7c0,0.2,0.2,0.4,0.4,0.4H12c0.2,0,0.4-0.2,0.4-0.4V14.9L12.4,14.9zM11.7,5.5c0-0.2-0.3-0.4-0.5-0.4H9.8c-0.2,0-0.4,0.2-0.4,0.4v1.1C9.4,6.8,9.6,7,9.8,7h1.5c0.2,0,0.4-0.2,0.4-0.4V5.5L11.7,5.5z" />
                                        )}
                                    </SvgIcon>
                                </span>
                            )
                        }
                    </Typography>
                </Grid>
                <Grid id={`delivery-fee-value-${deliveryFeeKey}`} className={classes.adujustMarginTop} data-testid={`delivery-fee-value-${deliveryFeeKey}`} item xs={4} md={3} lg={4} align="right" key={`delivery-fee-value-${deliveryFeeKey}`}>
                    { isInternationalization && <Typography component="span" className={`${classText} ${isConfirmationPage ? classes.textConfirmation : ''}`}>C${deliveryFeesList[deliveryFeeKey]}</Typography> }
                    { !isInternationalization && <Typography component="span" className={`${classText} ${isConfirmationPage ? classes.textConfirmation : ''}`}>${deliveryFeesList[deliveryFeeKey]}</Typography> }
                </Grid>
                {
                    openToggled[deliveryFeeKey] && (
                        <RegulatoryFeeInformation
                            deliveryInfoList={deliveryInfoList}
                            handleOpenToggled={handleOpenToggled}
                            isOpen={!!openToggled[deliveryFeeKey]}
                            toggledKey={deliveryFeeKey}
                            dataDictionary={dataDictionary}
                        />
                    )
                }
            </React.Fragment>
        ));

        return htmlLineFeeCharges;
    }
    return null;
};
DeliveryExtraFee.defaultProps = {
    orderDetail: false,
};

DeliveryExtraFee.propTypes = {
    classes: object.isRequired,
    flags: shape({
        'is-state-delivery-fee-enabled': bool,
    }).isRequired,
    orderDetail: bool,
    stateDeliveryFee: number.isRequired,
    dataDictionary: object.isRequired,
    isConfirmationPage: bool.isRequired,
};

export default withStyles(styles)(DeliveryExtraFee);
